import script from "./WhatsappSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsappSection.vue?vue&type=script&setup=true&lang=js"

import "./WhatsappSection.vue?vue&type=style&index=0&id=2ac13566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac13566"]])

export default __exports__